// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__q6sjN","wrapper_delete":"styles_wrapper_delete__mTpse","wrapper_filename":"styles_wrapper_filename__wM4g0"};